<footer class="footer mt-auto">
  <div class="container">

    <div class="img"></div>
    <div class="footer_LogoRepom float-left">
      <a
        href="https://edenred.com.br/"
        target="_blank">
        <img alt="Edenred Logo" src="/assets/img/logo-edenred.svg" class="footer_LogoRepomIMG">
      </a>
    </div>

    <div class="custom-shape-divider">
      @if (enableContactUs) {
        <div class="chat-button-content row">
          <a data-e2e="contact-us-button" class="contact-us-button col" ngbTooltip="FALE CONOSCO"
             href="/fale-conosco">
            <span class="visually-hidden">Fale Conosco</span>
          </a>
        </div>
      }
    </div>

  </div>
</footer>
